import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";

export const ConfluenceFreePage = () => {
    const signupPath = useLocalizedHref("/try/cloud/signup");
    location.href = `${signupPath}?bundle=confluence&edition=free`;
    return null;
};
